import React from 'react';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../Styles';

export const ChileLightFrictionFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.chileLightFriction.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Inc',
    },
    {
      description: 'supplierValidation.afterRegister.address',
      value: '135 Madison Ave, New York, NY 10016',
    },
    {
      description: 'supplierValidation.afterRegister.checkingAccount',
      value: '466007904549',
    },
    {
      description: 'supplierValidation.afterRegister.swift',
      value: 'supplierValidation.afterRegister.bofaWire.swiftValues',
    },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Bank of America,
        <br />
        222 Broadway,
        <br />
        New York, NY 10038
      </NormalText>
    ),
  },
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: ['supplierValidation.afterRegister.chileLightFriction.pleaseNote'],
    hideInvoice: true,
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: null,
  highlightedInstructions: {
    title: 'supplierValidation.afterRegister.chileLightFriction.willTransfer',
    additionalItems: [
      'supplierValidation.afterRegister.chileLightFriction.uponReceiving',
      'supplierValidation.afterRegister.chileLightFriction.youMayBeAsked',
    ],
  },
};
